// ─────────────────────────────────────────────────────────────────────────────
// Dépôts de prévision — GET /prevision-f/depots.
// Le service IA ne renvoie que les dépôts présents dans au moins une série
// valide (dépôts exclus du modèle, ex. VL, déjà retirés).
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect, useState } from "react";
import { getForecastDepots } from "./api";

export interface ForecastDepotsState {
  /** Codes dépôt, ex. ["DC", "DG", …]. Vide tant que le chargement n'est pas fini. */
  depots: string[];
  loading: boolean;
  error: string | null;
}

/** `reloadToken` : l'incrémenter relance le chargement (bouton Réessayer). */
export function useForecastDepots(reloadToken = 0): ForecastDepotsState {
  const [state, setState] = useState<ForecastDepotsState>({
    depots: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));
    getForecastDepots()
      .then((r) => {
        if (cancelled) return;
        if (r.success === false) {
          setState({ depots: [], loading: false, error: r.error || "Erreur inconnue du serveur" });
          return;
        }
        const depots = (r.data ?? [])
          .map((d) => (d.codDep ?? d.code_dep ?? d.cod_dep ?? "").trim())
          .filter(Boolean);
        setState({ depots, loading: false, error: null });
      })
      .catch((err) => {
        if (cancelled) return;
        setState({
          depots: [],
          loading: false,
          error: err instanceof Error ? err.message : "Erreur réseau inconnue",
        });
      });
    return () => {
      cancelled = true;
    };
  }, [reloadToken]);

  return state;
}
